document.addEventListener('DOMContentLoaded', () => {
  const faqListItem = document.querySelectorAll('.faq-section .faq-section-list .list-item');

  faqListItem.forEach(item => {
    const faqListItemBtn = item.querySelector('.list-item-btn');
    const faqListItemText = item.querySelector('.text');
    const maxHeight = faqListItemText.scrollHeight + 'px'; // Calcula la altura del contenido

    faqListItemBtn.addEventListener('click', () => {
      if (item.classList.contains('active')) {
        item.classList.remove('active');
        faqListItemText.style.maxHeight = '0'; // Cierra el elemento
      } else {
        faqListItem.forEach(otherItem => {
          otherItem.classList.remove('active');
          otherItem.querySelector('.text').style.maxHeight = '0'; // Cierra otros elementos
        });
        item.classList.add('active');
        faqListItemText.style.maxHeight = maxHeight; // Abre el elemento actual
      }
    });
  });
});
  